import React, { useEffect, useState, useRef, useMemo, useCallback } from "react";
import { Context, Hooks, Util, Request } from "@xt/xtbase";
const { XtContext, XtAuth } = Context;
const { useTranslation } = Hooks;
const { getUrl } = Util;
import getProductStatus from "components/Pages/Finance/_hook/getProductStatus";
import cx from "classnames";
import styles from "./index.module.less";
import { useStore } from "@/models";
import { observer } from "mobx-react-lite";
import { message } from "antd";

export default observer(({ data, callback, className }) => {
  const [appState] = React.useContext(XtContext);
  const t = useTranslation();
  const { finance } = useStore();

  const product = useMemo(() => {
    const { productId, financialProducts } = data;
    return financialProducts.find((obj) => obj.id === productId);
  }, [data]);

  //将data转化为组件selfData
  const selfData = useMemo(() => {
    let disabled = true;
    let label = t("finance.subscribe");

    // const { productId, financialProducts } = data;
    // const target = financialProducts.find((obj) => obj.id === productId);
    if (!product) return { disabled, label };

    const status = getProductStatus(product);

    disabled = status.disabled;
    status.reason === "soldOut" && (label = t("finance.soldOut"));

    return {
      disabled,
      label,
    };
  }, [product]);

  const onClick = useCallback(() => {
    if (appState.loginStatus != 1) {
      window.location.href = getUrl("/accounts/login?backurl=" + encodeURIComponent(window.location.href));
      return;
    }
    console.log(data, finance.isNewer);
    if (product && product.noviceExclusive && !finance.isNewer) {
      return message.warn(t("finance.productDisabled_newer"));
    }
    finance.showSubscribe = data;
  }, [data, appState.loginStatus, product]);

  return (
    <button className={cx("btnTxt", styles.main, className)} disabled={selfData.disabled} onClick={onClick}>
      {selfData.label}
    </button>
  );
});
